import stageConfig from './stage.json'
import prodConfig from './prod.json'

const isProdEnvironment = window.__ENV === 'PROD'

const config = isProdEnvironment
  ? prodConfig
  : stageConfig

export default config